import { SelectedUnits } from '../UnitSelection';

export function createUnitsString(units: SelectedUnits) {
  return Object.entries(units).reduce(
    (combined, [type, amount]) => combined.concat(combined.length > 0 ? ', ' : '', amount.toString(), 'x', type),
    ''
  );
}
